import * as ng from 'angular';

ng.module('selfReg')
   .directive('validateEmail', validateEmailDirective);

export function validateEmailDirective() {
   return {
      require: 'ngModel',
      link: validateEmailLink
   }
}

const EmailRegex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;

function validateEmailLink(scope, elm, attrs, ctrl:ng.INgModelController) {
   ctrl.$validators.email = isValidEmail;

   function isValidEmail(modelValue) {
      return ctrl.$isEmpty(modelValue) || EmailRegex.test(modelValue);
   }
}
